//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageInputItem } from './WebsiteBlockTextAndMediaImageInputItem';
import { WebsiteBlockTextAndMediaActionInputItem } from './WebsiteBlockTextAndMediaActionInputItem';
import { WebsiteBlockInputItem } from './WebsiteBlockInputItem';
import { IWebsiteBlockInputItemHasImages } from './IWebsiteBlockInputItemHasImages';
import { WebsiteBlockTextAndMediaType, WebsiteBlockType } from './Enums';

export class WebsiteBlockTextAndMediaInputItem extends WebsiteBlockInputItem implements IWebsiteBlockInputItemHasImages {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageInputItem[] = [];
    Action: WebsiteBlockTextAndMediaActionInputItem | null = null;
    TextAndMediaType: WebsiteBlockTextAndMediaType = WebsiteBlockTextAndMediaType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.TextAndMedia;

    constructor(initializer?: Partial<Omit<WebsiteBlockTextAndMediaInputItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockTextAndMediaInputItem";
}
